import WaitingTimeRateListPage from "./list/index.page";

export const waitingTimeRatePageRouteName = "/config/waiting-time-rate";

const WaitingTimeRatePage = () => {
  return <WaitingTimeRateListPage />;
};

export default WaitingTimeRatePage;
